// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderBar_header__crG0i","withLogo":"HeaderBar_withLogo__1WDsd","smallTitle":"HeaderBar_smallTitle__3mKOU"};